module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00634.49fe43be.jpg";